import { useEffect, useState } from 'react'
import { MobileTitle } from '../components/Title'
import ReactPlayer from 'react-player'
import { FullScreenModal } from '../utility/FullScreenModal'
export const Media = () => {
    const [isPlaying, setIsPlaying] = useState(null)
    const [showButton, setShowButton] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', url: '', index: 0 })

    const handleOpenModal = (contentType, category, url, index, maxIndex) => {
        setModalContent({ contentType, category, url, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.pageYOffset > 300) {
                setShowButton(true)
            } else {
                setShowButton(false)
            }
        })
    }, [])

    return (
        <>
            <div className='mt-32'>
                <div className='py-12 md:py-0 w-full text-center mx-auto'>
                    <span className='relative pt-2'>
                        <h1 className='md:hidden text-gradient-title text-lg font-pop inline-block'>Media</h1>{' '}
                    </span>
                </div>
                <div className='px-4'>
                    <div className='my-20 flex flex-col gap-16 max-w-[700px] mx-auto'>
                        <div className=' w-full text-center'>
                            {' '}
                            <span className='relative newicon-nav'>
                                {' '}
                                <h1 className='text-center text-gradient-title text-base md:text-lg  font-pop my-4'>
                                    Bande-annonce de lancement sur Steam
                                </h1>{' '}
                            </span>{' '}
                            <div className='video-thumb w-full text-center'>
                                {' '}
                                <img
                                    onClick={() => {
                                        handleOpenModal(
                                            'video',
                                            'home',
                                            'https://youtu.be/fBkkWDkbrHA?feature=shared',
                                            1
                                        )
                                    }}
                                    className='ss-thumb'
                                    alt='gameflow button'
                                    src={`${process.env.PUBLIC_URL}/images/steam-launch-trailer-thum.webp`}
                                />{' '}
                            </div>{' '}
                        </div>{' '}
                        <div className=' w-full text-center'>
                            {' '}
                            <span className='relative'>
                                {' '}
                                <h1 className='text-center text-gradient-title text-base md:text-lg  font-pop my-4'>
                                    Vidéo de l'annonce de la date de sortie sur Steam
                                </h1>{' '}
                            </span>{' '}
                            <div className='video-thumb w-full text-center'>
                                {' '}
                                <img
                                    onClick={() => {
                                        handleOpenModal('video', 'home', 'https://youtu.be/gdyTrNa_PFg', 1)
                                    }}
                                    className='ss-thumb'
                                    alt='gameflow button'
                                    src={`${process.env.PUBLIC_URL}/images/PB2_SteamRDA.webp`}
                                />{' '}
                            </div>{' '}
                        </div>{' '}
                        <div className=' w-full text-center'>
                            {' '}
                            <span className='relative'>
                                {' '}
                                <h1 className='text-center text-gradient-title text-base md:text-lg  font-pop my-4'>
                                    Bande-annonce de Lancement
                                </h1>{' '}
                            </span>{' '}
                            <div className='video-thumb w-full text-center'>
                                {' '}
                                <img
                                    onClick={() => {
                                        handleOpenModal('video', 'home', 'https://youtu.be/BxPMGEWbX1I', 1)
                                    }}
                                    className='ss-thumb'
                                    alt='gameflow button'
                                    src={`${process.env.PUBLIC_URL}/images/PB2_PV4.webp`}
                                />{' '}
                            </div>{' '}
                        </div>{' '}
                        <div className=' w-full text-center'>
                            {' '}
                            <span className='relative inline-block'>
                                {' '}
                                <h1 className='text-center text-gradient-title text-base md:text-lg  font-pop my-4'>
                                    Bande-annonce de la date de sortie
                                </h1>{' '}
                            </span>{' '}
                            <div className='video-thumb w-full text-center'>
                                {' '}
                                <img
                                    onClick={() => {
                                        handleOpenModal(
                                            'video',
                                            'home',
                                            'https://www.youtube.com/watch?v=Kxw1lJhAr6k',
                                            1
                                        )
                                    }}
                                    className='ss-thumb'
                                    alt='gameflow button'
                                    src={`${process.env.PUBLIC_URL}/images/pv2-thumb.webp`}
                                />{' '}
                            </div>{' '}
                        </div>{' '}
                        <div className=' w-full text-center'>
                            {' '}
                            <h1 className='text-center text-gradient-title text-base md:text-lg  font-pop my-4'>
                                Nintendo Direct 2024.6.18
                            </h1>{' '}
                            <div className='video-thumb'>
                                {' '}
                                <img
                                    onClick={() => {
                                        handleOpenModal(
                                            'video',
                                            'home',
                                            'https://www.youtube.com/watch?v=nuR3rUklk_I',
                                            1
                                        )
                                        console.log()
                                    }}
                                    className='ss-thumb video-thumb'
                                    alt='gameflow button'
                                    src={`${process.env.PUBLIC_URL}/images/NinDi.webp`}
                                />{' '}
                            </div>{' '}
                        </div>{' '}
                        <div className=' w-full text-center'>
                            {' '}
                            <h1 className='text-center text-gradient-title text-base md:text-lg  font-pop my-4'>
                                Bande-annonce
                            </h1>{' '}
                            <div className='video-thumb '>
                                <img
                                    onClick={() => {
                                        handleOpenModal(
                                            'video',
                                            'home',
                                            'https://www.youtube.com/watch?v=2Kd2HyQjvRE',
                                            1
                                        )
                                    }}
                                    className='ss-thumb'
                                    alt='gameflow button'
                                    src={`${process.env.PUBLIC_URL}/images/pv1-thumb.webp`}
                                />{' '}
                            </div>{' '}
                        </div>
                        {/* <div>
                            <div className='w-full text-center'>
                                <span className='relative newicon-nav inline-block '>
                                    {' '}
                                    <h1 className='text-center text-gradient-title text-base md:text-lg  font-pop my-4'>
                                        Bande-annonce de la date de sortie
                                    </h1>{' '}
                                </span>{' '}
                            </div>
                            <div className='video-container hover:scale-105 hover:brightness-110 duration-300'>
                                <ReactPlayer
                                    url='https://www.youtube.com/watch?v=Kxw1lJhAr6k'
                                    controls={true}
                                    onPlay={() => {
                                        setIsPlaying(1)
                                    }}
                                    width='100%'
                                    height='100%'
                                    playing={isPlaying === 1}
                                    config={{
                                        youtube: {
                                            playerVars: { showinfo: 1 },
                                        },
                                    }}
                                    className='react-player'
                                />
                            </div>{' '}
                        </div>{' '}
                        <div>
                            <div className='w-full text-center mt-12'>
                                <h1 className='text-center text-gradient-title text-base md:text-lg font-pop my-4'>
                                    Bande-annonce
                                </h1>{' '}
                            </div>
                            <div className='video-container hover:scale-105 hover:brightness-110 duration-300 mt-12'>
                                <ReactPlayer
                                    url='https://youtu.be/2Kd2HyQjvRE'
                                    controls={true}
                                    onPlay={() => {
                                        setIsPlaying(1)
                                    }}
                                    width='100%'
                                    height='100%'
                                    playing={isPlaying === 1}
                                    config={{
                                        youtube: {
                                            playerVars: { showinfo: 1 },
                                        },
                                    }}
                                    className='react-player'
                                />
                            </div>{' '}
                        </div> */}
                    </div>{' '}
                </div>{' '}
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={1}
                />
            </div>
        </>
    )
}
